import {
  GET_BASIC_BRANDS_V2,
  GET_BRAND_HASHTAGS,
  GET_BRAND_ID_LIST,
  GET_BRAND_ID_LIST_V2,
  GET_BRAND_CREATORS_TOTAL,
  GET_BRAND_TERRITORY,
  GET_BRANDS_BY_INDUSTRY,
  GET_BRANDS_FOR_DASHBOARD_TOOLBAR,
  GET_DISTRIBUTION_METRICS,
  GET_DISTRIBUTION_METRICS_V2,
  GET_LIST_BRAND_SOA_ON_CATEGORY_PAGINATED_QUERY,
  GET_LIST_REASONING_ON_BRAND_CATEGORY_QUERY,
  GET_TOTAL_SHARE,
  GET_TOTAL_SHARE_V2,
  GET_BRANDS_IN_TERRITORY,
} from './operations'
import type { BrandsQueriesMap } from './types'

export const GRAPH_BRANDS_QUERIES: BrandsQueriesMap = {
  getListBrandSOAOnCategoryPaginated: GET_LIST_BRAND_SOA_ON_CATEGORY_PAGINATED_QUERY,
  getListReasoningOnBrandCategory: GET_LIST_REASONING_ON_BRAND_CATEGORY_QUERY,
  getBrandDistributionMetrics: GET_DISTRIBUTION_METRICS,
  getBrandDistributionMetricsV2: GET_DISTRIBUTION_METRICS_V2,
  getTotalShare: GET_TOTAL_SHARE,
  getTotalShareV2: GET_TOTAL_SHARE_V2,
  getBrandIdList: GET_BRAND_ID_LIST,
  getBrandIdListV2: GET_BRAND_ID_LIST_V2,
  getBrandTerritory: GET_BRAND_TERRITORY,
  getBrandCreatorsTotal: GET_BRAND_CREATORS_TOTAL,
  getBrandHashtags: GET_BRAND_HASHTAGS,
  getBrandsForDashboardToolbar: GET_BRANDS_FOR_DASHBOARD_TOOLBAR,
  getBasicBrandsV2: GET_BASIC_BRANDS_V2,
  getBrandsByIndustry: GET_BRANDS_BY_INDUSTRY,
  getBrandsInTerritory: GET_BRANDS_IN_TERRITORY,
}
